class SHTCustomSortSelectBox extends HTMLElement {
  /**
   * Constructor
   */
  constructor() {
    super();
    this.elms = {
      select: this.querySelector("select"),
    };

    this.generateMarkUp();
    document.body.addEventListener("click", this.onBodyClick.bind(this));
  }
  /**
   * Close the currency switcher by enter key
   */
  onBodyClick(evt) {
    const target = evt.target;
    if (!this.contains(target)) {
      if (window.screen.width > 768) {
        this.closeSelectBox();
      }
    }
  }
  /**
   * Generate Mark Up for custom select box
   */
  generateMarkUp() {
    let me = this;

    let totalOptions = this.elms.select.length;

    let divForSelectedItem = document.createElement("DIV");
    divForSelectedItem.setAttribute("class", "select element pr");
    divForSelectedItem.setAttribute("data-type", "option");
    divForSelectedItem.innerHTML =
      this.elms.select.options[this.elms.select.selectedIndex].innerHTML;
    this.appendChild(divForSelectedItem);

    let divForOptionListContainer = document.createElement("DIV");
    divForOptionListContainer.setAttribute("class", "options pa wf invisible");
    divForOptionListContainer.setAttribute("data-type", "options");

    for (let j = 0; j < totalOptions; j++) {
      let divForOption = document.createElement("DIV");
      var delay = 0.2;
      const index = j * 0.05;
      var delay = delay + index;

      divForOption.setAttribute("class", "sort-option");
      divForOption.style.setProperty("--out", delay + "s");
      divForOption.style.setProperty("--in", j * 0.05 + "s");
      divForOption.innerHTML = this.elms.select.options[j].innerHTML;
      divForOption.addEventListener("click", function (e) {
        let svgTickIcon = me.querySelector("svg");
        if (svgTickIcon) {
          svgTickIcon.remove();
        }
        let tmpDivForSelectedItem = this.parentNode.previousSibling;
        for (let i = 0; i < totalOptions; i++) {
          if (me.elms.select.options[i].innerHTML == this.innerHTML) {
            me.elms.select.selectedIndex = i;
            tmpDivForSelectedItem.innerHTML = this.innerHTML;

            let sameSelectedOption = this.parentNode.querySelectorAll(
              `[data-type="option-current"]`
            );
            let totalSameSelectedOption = sameSelectedOption.length;
            for (let k = 0; k < totalSameSelectedOption; k++) {
              sameSelectedOption[k].removeAttribute("class");
            }

            this.setAttribute("class", "option-current fw-600 pr");
            this.setAttribute("data-type", "option-current");
            me.renderTickIcon(this);
            me.elms.select.dispatchEvent(new Event("input", { bubbles: true }));
            me.elms.select.dispatchEvent(
              new Event("change", { bubbles: true })
            );
          }
        }
        tmpDivForSelectedItem.click();
        document.querySelector('body').classList.remove('sht-modal-overflow-hidden');
        document.getElementById("Sort").classList.remove("modal-active");
      });
      divForOptionListContainer.appendChild(divForOption);
      this.setSelectedToDefaultOption(
        this.elms.select.options[this.elms.select.selectedIndex].innerHTML,
        divForOption
      );
    }
    this.append(divForOptionListContainer);

    if (window.screen.width > 768) {
      divForSelectedItem.addEventListener("click", function (e) {
        e.stopPropagation();
        me.closeAllOptions(this);
        this.nextSibling.classList.toggle("invisible");
        this.classList.toggle("select-open");
      });
    } else {
      this.querySelector('[data-type="option"]').classList.add("select-open");
      this.querySelector('[data-type="options"]').classList.remove("invisible");
    }
  }
  /**
   * Close Select box
   */
  closeSelectBox() {
    this.querySelector('[data-type="option"]').classList.remove("select-open");
    this.querySelector('[data-type="options"]').classList.add("invisible");
  }
  /** Set seclected to default option */
  setSelectedToDefaultOption(defaultValue, defaultOption) {
    if (defaultValue != "" && defaultValue == defaultOption.innerHTML) {
      defaultOption.setAttribute("data-type", "option-current");
      defaultOption.setAttribute("class", "option-current fw-600 pr");
      this.renderTickIcon(defaultOption);
    }
  }
  /**
   *
   * remove all selected item class
   * @param NodeHTML element
   */
  closeAllOptions(element) {
    let arrNo = [];

    let divForOptionListContainer = this.querySelector(`[data-type="options"]`);

    let divForSelectedItem = document.querySelector(`[data-type="option"]`);
    let totalDivForOptionListContainer = divForOptionListContainer.length;
    let totalDivForSelectedItem = divForSelectedItem.length;
    for (let i = 0; i < totalDivForSelectedItem; i++) {
      if (element == divForSelectedItem[i]) {
        arrNo.push(i);
      } else {
        divForSelectedItem[i].classList.remove("select-open");
      }
    }
    for (let i = 0; i < totalDivForOptionListContainer; i++) {
      if (arrNo.indexOf(i)) {
        divForOptionListContainer[i].classList.add("invisible");
      }
    }
  }
  /**
   * Render Tick icon
   * @param {*} node
   * @returns
   */
  renderTickIcon(node) {
    let iconSvg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
    let iconPath = document.createElementNS(
      "http://www.w3.org/2000/svg",
      "path"
    );
    iconSvg.setAttribute("fill", "currentColor");
    iconSvg.setAttribute("viewBox", "0 0 20 20");
    iconSvg.setAttribute("width", "20");
    iconSvg.setAttribute("height", "20");
    iconSvg.classList.add("pa");

    iconPath.setAttribute(
      "d",
      "M18.5303 3.46967C18.8232 3.76256 18.8232 4.23744 18.5303 4.53033L7.53035 15.5303C7.23745 15.8232 6.76258 15.8232 6.46969 15.5303L1.46967 10.5303C1.17678 10.2374 1.17678 9.76256 1.46967 9.46967C1.76256 9.17677 2.23744 9.17677 2.53033 9.46967L7.00002 13.9393L17.4697 3.46967C17.7626 3.17678 18.2374 3.17678 18.5303 3.46967Z"
    );
    iconPath.setAttribute("fill-rule", "evenodd");
    iconPath.setAttribute("clip-rule", "evenodd");

    iconSvg.appendChild(iconPath);

    return node.appendChild(iconSvg);
  }
}

customElements.define("sht-custom-sort-select-box", SHTCustomSortSelectBox);
